import { render, staticRenderFns } from "./WithdrawLimits.vue?vue&type=template&id=0d17efdf&"
import script from "./WithdrawLimits.vue?vue&type=script&lang=js&"
export * from "./WithdrawLimits.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawLimits.vue?vue&type=style&index=0&id=0d17efdf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports